import React, { useEffect, useMemo, useState } from 'react'
import { IconButton, ListItem, ListItemIcon, ListItemText, SvgIcon } from '@mui/material'
import { PencilAlt } from '@styled-icons/heroicons-solid'
import { useLazyGetBillingAddressQuery } from 'api/billing/billingAddress'
import { shallowEqual, useSelector } from 'react-redux'
import { get } from 'lodash'
import { combineAddressInfo } from 'utils/helper'
import EditBillingLocationModal from 'components/billing/EditBillingLocationModal'
import T from 'T'
import BillingAddressSkeleton from 'components/payments/BillingAddressSkeleton'

const BillingAddress = () => {
  const businessId = useSelector(state => get(state, 'LoginPersist.selectedLoginDetails.businessId'), shallowEqual)
  const accountId = useSelector(state => get(state, 'LoginPersist.selectedLoginDetails.accountId'), shallowEqual)
  const [isOpenEditBillingLocationDialog, setIsOpenEditBillingLocationDialog] = useState(false)

  const [getBillingAddress, { data: billingAddressData, isFetching: isGetBillingAddressLoading }] = useLazyGetBillingAddressQuery()

  const billingAddress = useMemo(() => get(billingAddressData, 'billingAddress', {}), [billingAddressData])
  const billingAddressStr = useMemo(() => {
    return combineAddressInfo(billingAddress) || 'No address saved'
  }, [billingAddress])
  const isBeneficialOwnerOverride = useMemo(() => get(billingAddress, 'isBeneficialOwnerOverride', false), [billingAddress])

  const onCloseEditBillingLocationDialog = () => {
    setIsOpenEditBillingLocationDialog(false)
  }

  const onSaveEditBillingLocationDialog = () => {
    setIsOpenEditBillingLocationDialog(false)
    getBillingAddress({ businessId, accountId })
  }

  const onOpenEditBillingLocationDialog = () => {
    setIsOpenEditBillingLocationDialog(true)
  }

  useEffect(() => {
    if (businessId && accountId) {
      getBillingAddress({ businessId, accountId })
    }
  }, [businessId, accountId])

  if (isGetBillingAddressLoading) {
    return <BillingAddressSkeleton />
  }

  return (
    <>
      <ListItem>
        <ListItemText
          primary={T.BILLING_ADDRESS}
          primaryTypographyProps={{ color: 'text.secondary', variant: 'body1' }}
          secondary={billingAddressStr}
          secondaryTypographyProps={{ color: 'text.primary', variant: 'body1' }}
        />
        <ListItemIcon>
          <IconButton onClick={onOpenEditBillingLocationDialog}>
            <SvgIcon fontSize="small" sx={{ color: 'text.secondary' }}>
              <PencilAlt />
            </SvgIcon>
          </IconButton>
        </ListItemIcon>
      </ListItem>
      <EditBillingLocationModal
        customerDetails={{ billingAddress }}
        open={isOpenEditBillingLocationDialog}
        onClose={onCloseEditBillingLocationDialog}
        onSave={onSaveEditBillingLocationDialog}
        isBeneficialOwnerOverride={isBeneficialOwnerOverride}
      />
    </>
  )
}

BillingAddress.propTypes = {}

export default BillingAddress
